import { sanitizePublicCopy } from '../lib/public-copy';

export default function PublicText({ as: Tag = 'span', children, className }) {
  const content =
    typeof children === 'string' ? sanitizePublicCopy(children) : children;
  return <Tag className={className}>{content}</Tag>;
}
